export default __webpack_public_path__ + "static/media/Waiting Room_2.463f056c.jpg";